import React from 'react';
import _get from 'lodash/get';

export default function SkinReport({
  actionButtonColor,
  buttonText,
  activeLang,
}) {
  return (
    <b
      className="skincaredetectionpreview-results__report"
      style={{backgroundColor: actionButtonColor}}
    >
      {_get(buttonText, `viewSkinReport.${activeLang}`)}
    </b>
  );
}
